import { render } from "./DetailPage.vue?vue&type=template&id=0b8b75d1&ts=true"
import script from "./DetailPage.ts?vue&type=script&lang=ts"
export * from "./DetailPage.ts?vue&type=script&lang=ts"

import "./DetailPage.vue?vue&type=style&index=0&id=0b8b75d1&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__